<template>
    <el-form @submit.native.prevent label-width="100px">
        <el-form-item label="单号:">
            <span>{{cardoperation.sysbillid}}</span>
            <span style="color: #409eff" v-if="cardoperation.paystatus==99">已生效</span>
            <span style="color: red" v-if="cardoperation.paystatus==-1">已驳回</span>
        </el-form-item>
        <el-form-item label="日期:">
            <span>{{cardoperation.accountdate}}</span>
        </el-form-item>
        <el-form-item label="单据类型:">
            <span v-if="cardoperation.billtype==1">开卡</span>
            <span v-if="cardoperation.billtype==2">充值</span>
        </el-form-item>
        <el-form-item label="会员姓名:">
            <span>{{cardoperation.membername}}</span>
        </el-form-item>
        <el-form-item label="会员卡号:">
            <span>{{cardoperation.cardnumber}}</span>
        </el-form-item>
        <el-form-item label="卡类型:">
            <span>{{cardoperation.cardtypename}}</span>
        </el-form-item>
        <el-form-item label="充值金额:">
            <span>{{cardoperation.amount}}</span>
        </el-form-item>
        <el-form-item label="支付方式:">
            <div v-for="(item,index) in payInfos" :key="index">
                {{item.payname}}:{{item.payamount}}
            </div>
        </el-form-item>

        <div style="text-align: center">
            <el-button type="danger" v-if="this.cardoperation.paystatus==1" :loading="loading" @click="updateCardOperationOnLineStatus" style="width: 30%">驳回</el-button>
            <el-button type="primary" v-if="this.cardoperation.paystatus==1" :loading="loading" @click="saveOpenCard" style="width: 30%">审核</el-button>
        </div>
    </el-form>
</template>
<script>
export default {
    data() {
        return {
            loading:false,
            cardoperation:{},
            payInfos:[],
            sysbillid:"",
        }
    },
    created() {
        let userId = this.getUrlKey("userId");
        let code = this.getUrlKey("code");
        this.sysbillid = this.getUrlKey("sysbillid");

        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCodeNew?state="+encodeURIComponent("http://staff.shmiaojie.cn/#/cardexamine?sysbillid="+this.sysbillid);
        }
    },
    methods:{
        getCorpUserInfo(staffid) {
            this.$post("wechat/getCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        this.staffid=data.staff.staffid;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        localStorage.setItem("storename", data.staff.storename);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("parentstoreid", data.staff.storeid);
                        this.getCardOperationOnLineBySysbillId();
                        this.getPayInfoOnLineBySysbillId();
                    }
                } else {
                    window.close();
                }
            });
        },
        saveOpenCard(){
            this.$dialog.confirm({
                title: '提醒',
                message: "您确定审核该单据吗？",
            }).then(() => {
                this.loading=true;
                let staffPerfs=[];
                let staffPerf={};
                staffPerf.storeid="";
                staffPerf.sysbillid=this.cardoperation.sysbillid;
                staffPerf.staffid=this.cardoperation.createtor;
                staffPerf.billtype=this.cardoperation.billtype;
                staffPerf.sharelv=1;
                staffPerf.shareamount=this.cardoperation.amount;
                staffPerfs.push(staffPerf);
                let cardoperationVo={};
                this.cardoperation.isback=0;
                cardoperationVo.cardOperation=this.cardoperation;
                cardoperationVo.payInfos=this.payInfos;
                cardoperationVo.staffPerfs=staffPerfs;
                let url="";
                if(this.cardoperation.billtype==1){
                    url="cardinfo/saveOpenCard";
                }
                else if(this.cardoperation.billtype==2){
                    url="cardinfo/saveCardRecharge";
                }
                this.$postw(url,cardoperationVo).then(res=>{
                    this.loading=false;
                    if(res.sucess){
                        this.cardoperation.paystatus=99;
                        this.$message({message: "审核成功", type: 'success'});
                    }
                });
            });
        },
        updateCardOperationOnLineStatus(){
            this.$dialog.confirm({
                title: '提醒',
                message: "您确定要驳回该单据吗？",
            }).then(() => {
                this.loading = true;
                this.$post("openbill/updateCardOperationOnLineStatus", {
                    sysbillid: this.sysbillid,
                    paystatus: -1
                }).then(res => {
                    this.loading = false;
                    if (res.sucess) {
                        this.cardoperation.paystatus = -1;
                        this.$message({message: "驳回成功", type: 'success'});
                    } else {
                        this.$message({message: res.message, type: 'error'});
                    }
                });
            });
        },
        getPayInfoOnLineBySysbillId(){
            this.$post("openbill/getPayInfoOnLineBySysbillId",{sysbillid:this.sysbillid}).then(res=>{
                if(res.sucess){
                    this.payInfos=res.object;
                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        },
        getCardOperationOnLineBySysbillId(){
            this.$post("openbill/getCardOperationOnLineBySysbillId",{sysbillid:this.sysbillid}).then(res=>{
                if(res.sucess){
                    this.cardoperation=res.object;
                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        },
        getMiLanCorpidCode(code){
            this.$post("wechatback/getMiLanCorpidCode",{code:code}).then(res=>{
                if(res.sucess){
                    let staff=res.object.staff;
                    let token=res.object.token;
                    localStorage.setItem("token",token);
                    localStorage.setItem("staffid", staff.staffid);
                    localStorage.setItem("deptid", staff.deptid);
                    localStorage.setItem("staffname", staff.staffname);
                    localStorage.setItem("posid", staff.posid);
                    localStorage.setItem("storename", staff.storename);
                    localStorage.setItem("storeid", staff.storeid);
                    localStorage.setItem("parentstoreid", staff.storeid);
                    this.getCardOperationOnLineBySysbillId();
                    this.getPayInfoOnLineBySysbillId();
                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/examine/cardexamine.vue